import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Redirect,
  Link,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom'
import { InboxOutlined } from '@ant-design/icons'
import {
  Spin,
  Row,
  Col,
  Button,
  Input,
  Breadcrumb,
  Form,
  message,
  Upload,
} from 'antd'
import '../../css/surgeon.scss'
import util from '../../util/util'
import { addEditCustomer } from '../../store/action/customer.action'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { fetchCustomer } from '../../store/action/customer.action'
import { addEditCompany, fetchCompany } from '../../store/action/company.action'

var form = undefined

const CompanyAdd = (props) => {
  const [company, setCompany] = useState(undefined)

  var history = useHistory()
  var params = useParams()
  var companyid = params.id

  useEffect(() => {
    getCompany()
  }, [])
  useEffect(() => {
    initializeForm()
  }, [company])

  var getCompany = async () => {
    if (!companyid) return
    var response = await props.getCompany(companyid)
    if (!response) return
    setCompany(response)
  }

  var initializeForm = () => {
    form.setFieldsValue({
      ...company,
      contact_name: company?.contact?.name,
      contact_email: company?.contact?.email,
      contact_phone: company?.contact?.phone,
      ...company?.address,
    })
  }

  var handleSubmit = (value) => {
    var input = {},
      contact = {},
      address = {}
    contact.phone = value.contact_phone
    contact.email = value.contact_email
    contact.name = value.contact_name
    address.line1 = value.line1
    address.line2 = value.line2
    address.city = value.city
    address.state = value.state
    address.zip = value.zip
    input._id = companyid
    input.name = value.name
    input.email = value.email
    input.phone = value.phone
    input.address = address
    input.contact = contact
    console.log(input)
    props.addEditCompany(input).then((response) => {
      if (response) {
        setCompany(undefined)
        history.push('/companies')
      }
    })
  }

  const uploadButton = (
    <div className='uploadText'>
      <p className='ant-upload-drag-icon'>
        <InboxOutlined />
      </p>
      <p className='ant-upload-text'>
        Click or drag file to this area to upload
      </p>
    </div>
  )

  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <Col className='surgeonAddContainer'>
      <Row>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to='/companies'>Companies</Link>
          </Breadcrumb.Item>
          {companyid ? (
            <Breadcrumb.Item>Edit</Breadcrumb.Item>
          ) : (
            <Breadcrumb.Item>Add</Breadcrumb.Item>
          )}
        </Breadcrumb>
      </Row>
      <Row align='middle' className='headerRow'>
        <Col className='headerText'>Company</Col>
      </Row>
      <Form ref={(e) => (form = e)} layout={'vertical'} onFinish={handleSubmit}>
        <Row gutter={20}>
          <Col flex='50%'>
            <Form.Item
              label='Name'
              name='name'
              rules={[{ required: true, message: 'Please enter name' }]}
            >
              <Input maxLength={50} />
            </Form.Item>
            <Form.Item label='Email' name='email'>
              <Input />
            </Form.Item>
            <Form.Item label='Phone' name='phone'>
              <PhoneInput className='phone-input' enableAreaCodes />
            </Form.Item>
            <Form.Item label='Contact - Name' name='contact_name'>
              <Input />
            </Form.Item>
            <Form.Item label='Contact - Email' name='contact_email'>
              <Input />
            </Form.Item>
            <Form.Item label='Contact - Phone' name='contact_phone'>
              <PhoneInput className='phone-input' enableAreaCodes />
            </Form.Item>
          </Col>
          <Col flex='50%'>
            <Form.Item style={{ marginBottom: 6 }} label='Address' name='line1'>
              <Input.TextArea placeholder='Line 1' rows={3} />
            </Form.Item>
            <Form.Item name='line2'>
              <Input.TextArea placeholder='Line 2' rows={1} />
            </Form.Item>
            <Form.Item label='City' name='city'>
              <Input />
            </Form.Item>
            <Form.Item label='State' name='state'>
              <Input />
            </Form.Item>
            <Form.Item label='Zip' name='zip'>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify='end'>
          <Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              className='submit-form-button'
            >
              {companyid ? 'Update' : 'Add'}
            </Button>
            <Button
              style={{ marginLeft: 20 }}
              type='primary'
              className='submit-form-button'
            >
              <Link to={'/companies'}>Cancel</Link>
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </Col>
  )
}

CompanyAdd.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.profile.isLoading,
    customer: state.profile.customer,
    company: state.profile.company,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCompany: (companyid) => dispatch(fetchCompany(companyid)),
    addEditCompany: (params) => dispatch(addEditCompany(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAdd)
